(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ibd-breadcrumbs"] && !Shopify.designMode) return;
  try {
    class IbdBreadcrumbs extends HTMLElement {
    constructor() {
      super();
    }
  }

  if (!customElements.get('ibd-breadcrumbs')) {
    customElements.define('ibd-breadcrumbs', IbdBreadcrumbs);
  }
  } catch(e) { console.error(e); }
})();

})();
